import { useEffect } from 'react';

import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';

import { useTrackSubpage } from '../../hooks/use-track-subpage/use-track-subpage';

type Props = {
  pageType: string;
};
export const SubpageTracking: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  pageType,
}) => {
  const { pageContext } = usePageContext();
  const trackSubpage = useTrackSubpage(pageContext.pageSlug);

  useEffect(() => {
    trackSubpage(pageType);
  }, []);

  return children;
};
